import React from "react";

import { Button, Container, Description, Footer, Header, Logo, Pros, Title, Wrapper } from "./styles";
import CheckIcon from "@material-ui/icons/Check";
import { Modal } from "react-bootstrap";

const ModalDescription = ({ show, handleClose, description, descriptionPros, title }) => {
	return (
		<Modal show={show} onHide={handleClose} centered size="lg">
			<Modal.Header closeButton>
				<Header>
					<Logo />
					<Title>{title}</Title>
				</Header>
			</Modal.Header>

			<Modal.Body>
				<Container>
					<Description dangerouslySetInnerHTML={{ __html: description }} />
					{Boolean(descriptionPros.length) &&
						descriptionPros.map((item) => (
							<Wrapper key={item.length}>
								<CheckIcon size={24} />
								<Pros>{item}</Pros>
							</Wrapper>
						))}
				</Container>
				<Footer>
					<Button onClick={handleClose}>Legal, continuar!</Button>
				</Footer>
			</Modal.Body>
		</Modal>
	);
};

export default ModalDescription;
